import {InputHTMLAttributes} from 'react';

import styled, {css} from 'styled-components';

import {StaticConfig} from 'config/staticConfig';
import {useChatBot} from 'features/ChatBot/utils';
import {withAnalyticsID} from 'shared/Ensighten/components/withAnalyticsID';
import {PageNameOverrideContext} from 'shared/Ensighten/utils';
import LoadingSpinner from 'shared/Icons/components/LoadingSpinner';
import {GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {intlFormatSingleMessage} from 'shared/IntlFormatMessage/utils/intlMesssageFormat';
import {IconSize, ZIndex} from 'styles/Base';
import {Colors} from 'styles/Colors';

const NEED_HELP_ICON = 'https://www.amica.com/content/dam/amica/boldchat/need-help-icon.svg';
const ACTIVE_CHAT_ICON = 'https://www.amica.com/content/dam/amica/boldchat/chat-active-icon.svg';

const baseIconStyles = css`
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: ${ZIndex.CHAT_BOT};
  height: 76px;
  width: 76px;
  border-radius: 100px;
  background-color: ${Colors.DARK_TEAL};
`;

const LoadingSpinnerWrapper = styled.div`
  ${baseIconStyles}
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NeedHelpIcon = withAnalyticsID<InputHTMLAttributes<HTMLInputElement>>(styled.input`
  ${baseIconStyles}
`);

const ChatBot = () => {
  const imageSrc = window.sessionStorage.getItem('ava_button') ? ACTIVE_CHAT_ICON : NEED_HELP_ICON;

  const {
    widgetState: {isOpen, loadingWidget, proactiveOffer},
    onClick
  } = useChatBot();

  if (isOpen || !StaticConfig.chatBotDeploymentID || proactiveOffer) {
    return null;
  }

  return loadingWidget ? (
    <LoadingSpinnerWrapper id="custom-launcher">
      <LoadingSpinner
        props={{
          size: IconSize.PX_24,
          color: Colors.NEAR_WHITE,
          css: {zIndex: ZIndex.CHAT_BOT},
          'aria-label': 'Loading chat bot'
        }}
      />
    </LoadingSpinnerWrapper>
  ) : (
    <PageNameOverrideContext.Provider value="ava-chat-bot">
      <NeedHelpIcon
        type="image"
        id="custom-launcher"
        alt={intlFormatSingleMessage(GLOBAL_TRANSLATIONS.NEED_HELP)}
        src={imageSrc}
        {...{onClick}}
        name="custom-launcher"
      />
    </PageNameOverrideContext.Provider>
  );
};

export default ChatBot;
